"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeInput = void 0;
var _core = require("@dragon/core");
var _pixi = require("pixi.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RangeInput = exports.RangeInput = /*#__PURE__*/function (_Container) {
  function RangeInput(min, max, key, action, horizontal) {
    var _this;
    _classCallCheck(this, RangeInput);
    _this = _callSuper(this, RangeInput);
    _defineProperty(_this, "SLIDE_LENGTH", 200);
    _defineProperty(_this, "SLIDE_WIDTH", 20);
    _defineProperty(_this, "SLIDE_COL", 0x00000);
    _defineProperty(_this, "SLIDE_X0", 0);
    _defineProperty(_this, "SLIDE_Y0", 0);
    _defineProperty(_this, "DISABLED", true);
    _defineProperty(_this, "HORIZONTAL", void 0);
    _defineProperty(_this, "MIN", void 0);
    _defineProperty(_this, "MAX", void 0);
    _defineProperty(_this, "dragging", void 0);
    _defineProperty(_this, "valuePercentage", void 0);
    _defineProperty(_this, "knob", void 0);
    _defineProperty(_this, "text", void 0);
    _defineProperty(_this, "header", void 0);
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "slide", void 0);
    _defineProperty(_this, "hide", function () {
      _this.visible = false;
    });
    _defineProperty(_this, "show", function () {
      _this.visible = true;
    });
    _defineProperty(_this, "hideHeader", function () {
      _this.header.visible = false;
    });
    _defineProperty(_this, "showHeader", function () {
      _this.header.visible = true;
    });
    _defineProperty(_this, "setHorizontal", function () {
      _this.HORIZONTAL = true;
      _this.draw();
      _this.setPosition(_this.valuePercentage);
    });
    _defineProperty(_this, "setVertical", function () {
      _this.HORIZONTAL = false;
      _this.draw();
      _this.setPosition(_this.valuePercentage);
    });
    _defineProperty(_this, "setPosition", function (percentage) {
      if (_this.HORIZONTAL) {
        _this.knob.position.y = 2;
        _this.knob.position.x = percentage * _this.SLIDE_LENGTH;
        // font specific.
        _this.text.position.x = _this.knob.position.x + 3;
        _this.text.y = -4;
        // font specific.
        _this.header.x = _this.SLIDE_LENGTH / 2;
      } else {
        _this.knob.position.x = 0;
        _this.knob.position.y = (1 - percentage) * _this.SLIDE_LENGTH;
        // font specific.
        _this.text.position.y = _this.knob.position.y - 5;
        // font specific.
        _this.text.position.x = 3;
        _this.header.x = 0;
      }
    });
    _defineProperty(_this, "draw", function () {
      _this.slide.clear();
      if (_this.HORIZONTAL) {
        _this.slide.lineTextureStyle({
          width: _this.SLIDE_WIDTH,
          color: _this.SLIDE_COL,
          cap: _pixi.LINE_CAP.ROUND,
          alpha: 1
        }).moveTo(_this.SLIDE_X0, _this.SLIDE_Y0).lineTo(_this.SLIDE_LENGTH - _this.SLIDE_X0, _this.SLIDE_Y0);
      } else {
        _this.slide.lineTextureStyle({
          width: _this.SLIDE_WIDTH,
          color: _this.SLIDE_COL,
          cap: _pixi.LINE_CAP.ROUND,
          alpha: 1
        }).moveTo(_this.SLIDE_X0, _this.SLIDE_Y0).lineTo(_this.SLIDE_X0, _this.SLIDE_LENGTH + _this.SLIDE_Y0);
      }
    });
    _this.MIN = min;
    _this.MAX = max;
    _this.slide = new _pixi.Graphics();
    _this.HORIZONTAL = horizontal;
    _this.slide.alpha = 0.8;
    _this.draw();
    var texture = _pixi.Texture.from("blitz_slider_knob.png");
    _this.knob = new _pixi.Sprite(texture);
    _this.knob.scale.set(1.2);
    _this.knob.interactive = true;
    _this.knob.buttonMode = true;
    _this.knob.anchor.x = 0.5;
    _this.knob.anchor.y = 0.5;
    _this.knob.position.x = _this.SLIDE_X0;
    _this.knob.position.y = _this.SLIDE_Y0;

    // use the mousedown and touchstartthis.
    var onStart = function onStart() {
      if (_this.DISABLED) return;
      //   this.alpha = 0.9;
      _this.dragging = true;
    };
    _this.knob.on("mousedown", onStart);
    _this.knob.on("touchstart", onStart);

    // set the events for when the mouse is released or a touch is released
    var onEnd = function onEnd() {
      // this.alpha = 1
      _this.dragging = false;
    };
    _this.knob.on("mouseup", onEnd);
    _this.knob.on("mouseupoutside", onEnd);
    _this.knob.on("touchend", onEnd);
    _this.knob.on("touchcancel", onEnd);

    // set the callbacks for when the mouse or a touch moves

    var onMove = function onMove(data) {
      if (_this.dragging) {
        var newPosition = _this.slide.toLocal(data.data.global);
        if (_this.HORIZONTAL) {
          if (newPosition.y > 35 || newPosition.y < -35) {
            onEnd();
            return;
          }
          if (newPosition.x > _this.SLIDE_X0 && newPosition.x < _this.SLIDE_X0 + _this.SLIDE_LENGTH) _this.knob.position.x = newPosition.x;else if (newPosition.x < _this.SLIDE_X0) _this.knob.position.x = 0;else if (newPosition.x > _this.SLIDE_X0 + _this.SLIDE_LENGTH) _this.knob.position.x = _this.SLIDE_X0 + _this.SLIDE_LENGTH;
          _this.valuePercentage = _this.knob.position.x / _this.SLIDE_LENGTH;
          _this.value = Math.round(_this.valuePercentage * 100 * (max - min) / 100 + min);
          _this.text.text = _this.value;
        } else {
          if (newPosition.x > 35 || newPosition.x < -35) {
            onEnd();
            return;
          }
          if (newPosition.y > _this.SLIDE_Y0 && newPosition.y < _this.SLIDE_Y0 + _this.SLIDE_LENGTH) _this.knob.position.y = newPosition.y;else if (newPosition.y < _this.SLIDE_Y0) _this.knob.position.y = 0;else if (newPosition.y > _this.SLIDE_Y0 + _this.SLIDE_LENGTH) _this.knob.position.y = _this.SLIDE_Y0 + _this.SLIDE_LENGTH;
          _this.text.position.y = _this.knob.position.y - 8;
          _this.valuePercentage = (_this.knob.position.y - _this.SLIDE_LENGTH) * -1 / _this.SLIDE_LENGTH;
          _this.value = Math.round(_this.valuePercentage * 100 * (max - min) / 100 + min);
          _this.text.text = _this.value;
        }
        _core.CORE.dispatch({
          type: action,
          payload: _this.value
        });
      }
    };
    _this.knob.on("mousemove", onMove);
    _this.knob.on("touchmove", onMove);
    _this.addChild(_this.slide);
    _this.addChild(_this.knob);
    _this.text = new _pixi.BitmapText("", {
      fontName: "blitzgoldbm",
      fontSize: 40,
      align: 'center',
      letterSpacing: -26
    });
    _this.text.anchor.set(0.5);
    _this.addChild(_this.text);
    var headerStyle = new _pixi.TextStyle({
      fontSize: 18,
      fill: ["#ffffff"],
      // gradient
      stroke: "#000000",
      strokeThickness: 2,
      fontFamily: ["NotoSansJPRegular", "InterMedium", "RoundedMplusRegular", "Helvetica", "Arial", "sans-serif"]
    });
    _this.header = new _pixi.Text(_core.CORE.translate("blitzroundsHud"), headerStyle);
    _this.header.anchor.set(0.5);
    _this.header.y = -50;
    _this.addChild(_this.header);
    _core.CORE.subscribe(key, function (f) {
      _this.text.text = f.toString();
      _this.value = f;
      _this.valuePercentage = (f - _this.MIN) * 100 / (_this.MAX - _this.MIN) / 100;
      _this.setPosition(_this.valuePercentage);
    });
    _core.CORE.subscribe("blitz.playing", function (a) {
      if (a) {
        _this.knob.interactive = false;
        _this.DISABLED = true;
        _this.alpha = 0.7;
      } else {
        _this.knob.interactive = true;
        _this.alpha = 1;
        _this.DISABLED = false;
      }
    });
    return _this;
  }
  _inherits(RangeInput, _Container);
  return _createClass(RangeInput);
}(_pixi.Container);
//# sourceMappingURL=RangeInput.js.map